export class APIError extends Error {
    code: number;
    codeText: string;
    serviceErrorCode?: number;

    constructor(message: string, code: number, codeText: string, serviceErrorCode?: number) {
        super(message);
        this.name = "APIError";
        this.message = message || "Something bad happened";
        this.stack = new Error().stack;
        this.code = code;
        this.codeText = codeText;
        this.serviceErrorCode = serviceErrorCode;
    }
}
